import type { SVGProps } from 'react';
const DawnFlagFI = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-FI_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-FI_svg__a)">
      <path
        fill="#0848A6"
        fillRule="evenodd"
        d="M-1.048 9.6h7.333v7.467h3.143V9.6h13.62V6.4H9.427v-7.467H6.285V6.4h-7.333z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagFI;
